/* =============================================
   SIZE CHART WIDGET — JAVASCRIPT
   Load this file from your theme, NOT from metafield.
   Add to product template:
   <script src="{{ 'size-chart-tabs.js' | asset_url }}" defer></script>
   ============================================= */
(function () {

  if (typeof window._sgUnit === 'undefined') { window._sgUnit = 'in'; }

  /* ---- Convert inch range string ---- */
  function sgConvert(raw, unit) {
    return raw.split('-').map(function (n) {
      var num = parseFloat(n.trim());
      if (isNaN(num)) return n.trim();
      return unit === 'cm' ? Math.round(num * 2.54) : num;
    }).join(' \u2013 ');
  }

  /* ---- Apply unit inside widget ---- */
  function applyUnit(W, unit) {
    W.querySelectorAll('.sg-convert').forEach(function (el) {
      el.textContent = sgConvert(el.getAttribute('data-in') || '', unit);
    });
    W.querySelectorAll('.sg-unit-ind').forEach(function (el) { el.textContent = unit; });
    var note = W.querySelector('.sg-note-txt');
    if (note) note.textContent = unit === 'cm'
      ? 'All measurements are in centimeters.'
      : 'All measurements are in inches.';
    W.querySelectorAll('.sg-mcv').forEach(function (el) {
      var cm = parseFloat(el.getAttribute('data-cm'));
      if (!isNaN(cm)) el.textContent = unit === 'in' ? (cm / 2.54).toFixed(1) : cm;
    });
    W.querySelectorAll('.sg-unit-mod').forEach(function (el) { el.textContent = unit; });
    W.querySelectorAll('[data-sg-unit]').forEach(function (btn) {
      if (btn.getAttribute('data-sg-unit') === unit) {
        btn.classList.add('sg-u-on');
      } else {
        btn.classList.remove('sg-u-on');
      }
    });
  }

  /* ---- Switch tab ---- */
  function switchTab(W, tabId) {
    W.querySelectorAll('[data-sg-tab]').forEach(function (btn) {
      if (btn.getAttribute('data-sg-tab') === tabId) {
        btn.classList.add('sg-t-on');
      } else {
        btn.classList.remove('sg-t-on');
      }
    });
    W.querySelectorAll('[data-sg-panel]').forEach(function (panel) {
      if (panel.getAttribute('data-sg-panel') === tabId) {
        panel.style.cssText = 'display:block!important;padding-top:20px';
      } else {
        panel.style.cssText = 'display:none!important';
      }
    });
  }

  /* ---- Init a widget ---- */
  function initWidget(W) {
    if (W._sgReady) return;
    W._sgReady = true;
    switchTab(W, 'measurements');
    applyUnit(W, window._sgUnit);
  }

  /* ---- Document-level click — capture phase fires before popup handlers ---- */
  document.addEventListener('click', function (e) {
    var clicked = e.target;

    var tabBtn  = clicked.closest ? clicked.closest('[data-sg-tab]')  : null;
    var unitBtn = clicked.closest ? clicked.closest('[data-sg-unit]') : null;

    /* Fallback: manual walk-up */
    if (!tabBtn && !unitBtn) {
      var el = clicked;
      while (el && el !== document.body) {
        if (el.getAttribute) {
          if (el.getAttribute('data-sg-tab'))  { tabBtn  = el; break; }
          if (el.getAttribute('data-sg-unit')) { unitBtn = el; break; }
        }
        el = el.parentNode;
      }
    }

    if (!tabBtn && !unitBtn) return;

    var W = document.getElementById('sg-size-widget');
    if (!W) return;

    if (tabBtn && W.contains(tabBtn)) {
      switchTab(W, tabBtn.getAttribute('data-sg-tab'));
    }
    if (unitBtn && W.contains(unitBtn)) {
      window._sgUnit = unitBtn.getAttribute('data-sg-unit');
      applyUnit(W, window._sgUnit);
    }
  }, true);

  /* ---- Theme-level IN/CM buttons ---- */
  document.addEventListener('click', function (e) {
    var W = document.getElementById('sg-size-widget');
    if (!W || W.contains(e.target)) return;
    var txt = (e.target.textContent || '').trim().toUpperCase();
    if (txt === 'CM' || txt === 'IN') {
      window._sgUnit = txt.toLowerCase();
      applyUnit(W, window._sgUnit);
    }
  });

  /* ---- MutationObserver: detect when popup injects widget into DOM ---- */
  if (window.MutationObserver) {
    var obs = new MutationObserver(function () {
      var W = document.getElementById('sg-size-widget');
      if (W) initWidget(W);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  /* ---- Immediate init ---- */
  function tryInit() {
    var W = document.getElementById('sg-size-widget');
    if (W) initWidget(W);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

})();
